// components/EmptyCart.jsx - Functional Empty Cart
import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import emptyBasket from '../../../assets/images/empty.png';
import useResponsive from '../hooks/useResponsive';
import BottomNavigation from './BottomNavigation';

const EmptyCart = ({ translate }) => {
  const { isMobile } = useResponsive();
  return (
    <>
      <Card>
        <Card.Body>
          <div className='d-flex justify-content-center align-items-center flex-column' style={{ marginTop: isMobile ? '80px' : '0px' }}>
            <img width={'200px'} className={'flex-item'} src={emptyBasket} alt='سبد خالی' />
            <span className={'flex-item text-center'}>{translate('empty_cart')}</span>
          </div>
          <p className='text-center mt-3'>می‌توانید برای مشاهده محصولات بیشتر به صفحات زیر بروید</p>
          <div className='flex-row d-flex justify-content-center'>
            <Link to={'/store'} className={'c-font-sm flex-item mr-4'}>
              <span>{translate('go_to_store')}</span>
              <i className='fa fa-store ml-1'></i>
            </Link>
            <Link to={'/'} className={'c-font-sm flex-item'}>
              <span>
                {translate('go_to_home')}
                <i className='fa fa-home ml-1'></i>
              </span>
            </Link>
          </div>
        </Card.Body>
      </Card>
      {isMobile && <BottomNavigation />}
    </>
  );
};

export default EmptyCart;
